import React from "react";
import { Box } from "@mui/material";
import HomeHero from "../components/home/HomeHero";
import CompareSpotlight from "../components/home/CompareSpotlight";
import AllTimeGreatsEntry from "../components/home/AllTimeGreatsEntry";
import MyLineupEntry from "../components/home/MyLineupEntry";
import TriviaChallenge from "../components/home/TriviaChallenge";
import TodaysDebateSection from "../components/community/TodaysDebateHero";
import CommunityModule from "../components/home/CommunityModule";
import TodaySlate from "../components/home/TodaySlate";
import HotPlayersRow from "../components/home/HotPlayersRow";
import QuickActions from "../components/home/QuickActions";
import YourWidgetsSection from "../components/home/YourWidgetsSection";

const Home = () => (
  <Box sx={{ py: { xs: 1, sm: 2 }, maxWidth: 1200, mx: "auto" }}>
    <HomeHero />
    <CompareSpotlight />
    <MyLineupEntry />
    <AllTimeGreatsEntry />
    <TriviaChallenge />
    <TodaysDebateSection sport="mlb" />
    <CommunityModule sport="mlb" />
    <TodaySlate />
    <HotPlayersRow />
    <QuickActions />
    <YourWidgetsSection />
  </Box>
);

export default Home;
